import { render } from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=template&id=2f783eda&scoped=true"
import script from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=style&index=0&id=2f783eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f783eda"]])

export default __exports__